import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env?.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env?.VITE_SUPABASE_ANON_KEY;

let supabase = null;
let initError = null;

// Only initialize if we have valid credentials
if (supabaseUrl && supabaseAnonKey && supabaseUrl?.startsWith('http')) {
  try {
    supabase = createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
        storageKey: 'sb-auth-token',
        flowType: 'pkce',
        // Disable navigator locks entirely to prevent LockManager errors
        lock: false
      }
    });
    console.log('✓ Supabase initialized');
  } catch (error) {
    console.error('✗ Supabase init error:', error);
    initError = 'Database connection failed';
    supabase = null;
  }
} else {
  console.warn('⚠ Supabase credentials missing');
  initError = 'Database not configured';
}

export { supabase, initError };
export default supabase;